import { render, staticRenderFns } from "./pkgCategory.vue?vue&type=template&id=096e4556&scoped=true&"
import script from "./pkgCategory.vue?vue&type=script&lang=js&"
export * from "./pkgCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e4556",
  null
  
)

export default component.exports